import React from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import YesNoQuestionnaire from 'components/shared/YesNoQuestionnaire';
import { questions } from '../AssistedPassengerSelection.constants';
import { RadioButtonLegend } from '../AssistedPassengerSelection.styles';
import { noPassengers } from '../../../BookingMagnet.constants';
import AlertBox from 'components/ui/AlertBox';
import { disabilityTypes } from '../../../BookingMagnet.constants';

const WheelchairPassengerSelection = ({ onChangePassengers, containDBStation = false, disabilityType = disabilityTypes.WHEELCHAIR }) =>
  disabilityType === disabilityTypes.WHEELCHAIR && containDBStation ? (
    <AlertBox variant={AlertBox.variants.WARNING}>
      <FormattedMessage id="bookingMagnet.dbWheelchairImpossible" />
    </AlertBox>
  ) : (
    <YesNoQuestionnaire
      onAllAnswersSelected={(answers) => {
        onChangePassengers({
          ...noPassengers,
          wheelchairCompanions: answers[questions.WITH_COMPANION] ? 1 : 0,
          [answers[questions.OLDER_THAN_TWELVE] ? 'adultsWheelchair' : 'childrenWheelchair']: 1
        });
      }}
      questions={[
        {
          name: questions.OLDER_THAN_TWELVE,
          legend: (
            <RadioButtonLegend>
              <FormattedMessage id="wheelchairSearch.questions.olderThanTwelve" />
            </RadioButtonLegend>
          )
        },
        {
          name: questions.WITH_COMPANION,
          legend: (
            <RadioButtonLegend>
              <FormattedMessage id="wheelchairSearch.questions.withCompanion" />
            </RadioButtonLegend>
          )
        }
      ]}
    />
  );

WheelchairPassengerSelection.propTypes = {
  onChangePassengers: PropTypes.func.isRequired,
  containDBStation: PropTypes.bool,
  disabilityType: PropTypes.string
};

export default WheelchairPassengerSelection;
